import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PaymentReceiptTypeView } from "./PaymentReceiptTypeView";
import { PaymentReceiptTypeViewStore } from "../../store/PaymentReceiptTypeViewStore";
import { useStore } from "../../../../hooks";

export const PaymentReceiptTypeViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/paymentReceiptType/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PaymentReceiptTypeViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PaymentReceiptTypeView paymentReceiptTypeViewStore={store} />
      </PageLayout>
    </div>
  );
});
